export default "__VITE_ASSET__ce6af1c1__"